if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainButtonId = this.dataset.mainButtonId;

        this.stickyButton = this.querySelector('[data-sticky-atc-button]');
        this.stickyLabel = this.querySelector('[data-sticky-atc-label]');
        this.stickyPrice = this.querySelector('[data-sticky-atc-price]');
        this.stickyButtonPrice = this.querySelector(
          '[data-sticky-atc-button-price]'
        );

        this.mainButton = document.getElementById(this.mainButtonId);

        if (!this.mainButton || !this.stickyButton) {
          this.remove();
          return;
        }

        this.onStickyClick = this.handleStickyClick.bind(this);

        this.stickyButton.addEventListener(
          'click',
          this.onStickyClick
        );

        this.syncButtonState();
        this.observeMainButton();
        this.observeMainButtonVisibility();
        this.subscribeToVariantChanges();

        this.hidden = false;
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener(
          'click',
          this.onStickyClick
        );

        this.visibilityObserver?.disconnect();
        this.buttonObserver?.disconnect();
        this.variantUnsubscriber?.();
      }

      handleStickyClick() {
        const mainButton = document.getElementById(this.mainButtonId);

        if (!mainButton) return;

        if (
          mainButton.disabled ||
          mainButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        mainButton.click();
      }

      observeMainButtonVisibility() {
        this.visibilityObserver = new IntersectionObserver(
          ([entry]) => {
            const hasScrolledPastButton =
              !entry.isIntersecting &&
              entry.boundingClientRect.bottom <= 0;

            this.classList.toggle(
              'is-visible',
              hasScrolledPastButton
            );

            this.setAttribute(
              'aria-hidden',
              hasScrolledPastButton ? 'false' : 'true'
            );
          },
          {
            threshold: 0,
          }
        );

        this.visibilityObserver.observe(this.mainButton);
      }

      observeMainButton() {
        this.buttonObserver = new MutationObserver(() => {
          this.syncButtonState();
        });

        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: [
            'disabled',
            'aria-disabled',
            'aria-haspopup',
            'class',
          ],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      syncButtonState() {
        const mainButton = document.getElementById(this.mainButtonId);

        if (!mainButton) return;

        this.mainButton = mainButton;

        const mainLabel = mainButton.querySelector('span');

        if (mainLabel && this.stickyLabel) {
          this.stickyLabel.textContent =
            mainLabel.textContent.trim();
        }

        const disabled =
          mainButton.disabled ||
          mainButton.getAttribute('aria-disabled') === 'true';

        this.stickyButton.disabled = disabled;

        this.stickyButton.classList.toggle(
          'button--primary',
          mainButton.classList.contains('button--primary')
        );

        this.stickyButton.classList.toggle(
          'button--secondary',
          mainButton.classList.contains('button--secondary')
        );

        if (mainButton.hasAttribute('aria-haspopup')) {
          this.stickyButton.setAttribute(
            'aria-haspopup',
            mainButton.getAttribute('aria-haspopup')
          );
        } else {
          this.stickyButton.removeAttribute('aria-haspopup');
        }
      }

      subscribeToVariantChanges() {
        if (
          typeof subscribe !== 'function' ||
          typeof PUB_SUB_EVENTS === 'undefined'
        ) {
          return;
        }

        this.variantUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          ({ data }) => {
            if (data.sectionId !== this.sectionId) return;

            this.syncButtonState();
            this.syncPrice(data.html);
          }
        );
      }

      syncPrice(html) {
        if (!html) return;

        const sourcePrice = html.getElementById(
          `price-${this.sectionId}`
        );

        if (this.stickyPrice && sourcePrice) {
          this.stickyPrice.innerHTML = sourcePrice.innerHTML;
        }

        const sourceButtonPrice = html.querySelector(
          '[data-sticky-atc-button-price]'
        );

        if (this.stickyButtonPrice && sourceButtonPrice) {
          this.stickyButtonPrice.innerHTML =
            sourceButtonPrice.innerHTML;
        }
      }
    }
  );
}